import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Button } from "@/shared/ui/Button";
import { Modal } from "@/shared/ui/Modal";
import styles from "./InstrumentalConfirmModal.module.scss";
/**
 * Подтверждение создания минуса (инструментала). Генерация минуса — платная
 * операция: списывает 1 песню с баланса, поэтому подтверждаем явно.
 */
export const InstrumentalConfirmModal = ({ opened, onClose, onConfirm, language, }) => {
    const [submitting, setSubmitting] = useState(false);
    const handleConfirm = async () => {
        setSubmitting(true);
        try {
            await onConfirm();
            onClose();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsxs(Modal, { opened: opened, onClose: onClose, size: "sm", title: language === "ru" ? "Создать минус" : "Create instrumental", closeOnBackdropClick: !submitting, closeOnEscape: !submitting, children: [_jsx("p", { className: styles.description, children: language === "ru"
                    ? "Создание минуса спишет 1 песню с вашего баланса. Продолжить?"
                    : "Creating an instrumental will deduct 1 song from your balance. Continue?" }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { variant: "ghost", size: "md", onClick: onClose, disabled: submitting, children: language === "ru" ? "Отмена" : "Cancel" }), _jsx(Button, { variant: "primary", size: "md", onClick: () => void handleConfirm(), disabled: submitting, children: submitting
                            ? language === "ru"
                                ? "Создаём…"
                                : "Creating…"
                            : language === "ru"
                                ? "Создать за 1 песню"
                                : "Create for 1 song" })] })] }));
};
